/* eslint-disable no-useless-catch */
import { loaderService } from 'src/services/loaderService'
import apiService from 'src/enviroment'

export const getGDCParners = async () => {
  loaderService.show()
  try {
    const { data } = await apiService.get('/gdc/socios_comerciales')
    if (data.success) {
      return data
    }
    return { socios: [] }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const getGDCClusters = async ({ partner }) => {
  loaderService.show()
  try {
    const { data } = await apiService.get(
      `/gdc/clusters?solicitante=${partner}`,
    )
    if (data.success) {
      return data
    }
    return { cluster: [] }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const getGDCScore = async ({ partner }) => {
  loaderService.show()
  try {
    const { data } = await apiService.get(
      `/gdc/puntos_guia?solicitante=${partner}`,
    )
    if (data.success) {
      return data
    }
    return { puntos_guia: [] }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const getGDCBitacora = async ({ partner, clusterId }) => {
  loaderService.show()
  try {
    const { data } = await apiService.get(
      `/gdc/bitacora?cluster_id=${clusterId}&solicitante=${partner}`,
    )
    if (data.success) {
      return data
    }
    return { hoja_ruta: [] }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const postGDCBitacoraText = async ({ params }) => {
  loaderService.show()
  try {
    const { data } = await apiService.post('/gdc/bitacora/texto', params)
    if (data.success) {
      return data
    }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const postGDCBitacoraFile = async ({ params }) => {
  loaderService.show()
  try {
    const { data } = await apiService.post('/gdc/bitacora/archivo', params)
    if (data.success) {
      return data
    }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}
export const deleteGDCBitacoraFile = async ({ id }) => {
  loaderService.show()
  try {
    const { data } = await apiService.delete(`gdc/bitacora?id=${id}`)
    if (data.success) {
      return data
    }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const postProccessOk = async ({ params }) => {
  loaderService.show()
  try {
    const { data } = await apiService.post('gdc/proceso/ok', params)
    if (data.success) {
      return data
    }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const getGDCRoadMap = async ({ partner }) => {
  loaderService.show()
  try {
    const { data } = await apiService.get(
      `/gdc/hoja_ruta?solicitante=${partner}`,
    )
    if (data.success) {
      return data
    }
    return { bitacora: [] }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const getGDCMatriz = async ({ partner }) => {
  loaderService.show()
  try {
    const { data } = await apiService.get(
      `/gdc/matriz_impacto?solicitante=${partner}`,
    )
    if (data.success) {
      return data
    }
    return { matriz_impacto: [] }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const updateGDCScore = async ({ params }) => {
  loaderService.show()
  try {
    const { data } = await apiService.post('/gdc/puntos_guia', params)
    if (data.success) {
      return data
    }
    return { cluster: [] }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const postGDCRoadMap = async ({ params }) => {
  loaderService.show()
  try {
    const { data } = await apiService.post('/gdc/hoja_ruta', params)
    if (data.success) {
      return data
    }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const putGDCRoadMap = async ({ params }) => {
  loaderService.show()
  try {
    const { data } = await apiService.put('/gdc/hoja_ruta', params)
    if (data.success) {
      return data
    }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const deleteGDCRoadMap = async ({ id }) => {
  loaderService.show()
  try {
    const { data } = await apiService.delete(`/gdc/hoja_ruta?id=${id}`)
    if (data.success) {
      return data
    }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const getGDCDetaliedPlan = async ({ partner }) => {
  loaderService.show()
  try {
    const { data } = await apiService.get(`gdc/plan_detallado?solicitante=${partner}`)
    if (data.success) {
      return data
    }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const postGDCDetaliedPlan = async ({ params }) => {
  loaderService.show()
  try {
    const { data } = await apiService.post('/gdc/plan_detallado', params)
    if (data.success) {
      return data
    }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const putGDCDetaliedPlan = async ({ params }) => {
  loaderService.show()
  try {
    const { data } = await apiService.put('/gdc/plan_detallado', params)
    if (data.success) {
      return data
    }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const deleteGDCDetaliedPlan = async ({ id }) => {
  loaderService.show()
  try {
    const { data } = await apiService.delete(`/gdc/plan_detallado?id=${id}`)
    if (data.success) {
      return data
    }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const getGDCDetaliedPlanHistory = async ({ id }) => {
  loaderService.show()
  try {
    const { data } = await apiService.get(`/gdc/plan_detallado/historico?plan_id=${id}`)
    if (data.success) {
      return data
    }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const postGDCDetaliedPlanHistory = async ({ params }) => {
  loaderService.show()
  try {
    const { data } = await apiService.post('/gdc/plan_detallado/historico', params)
    if (data.success) {
      return data
    }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const deleteGDCDetaliedPlanHistory = async ({ id }) => {
  loaderService.show()
  try {
    const { data } = await apiService.delete(`/gdc/plan_detallado/historico?id=${id}`)
    if (data.success) {
      return data
    }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const getGDCRoadMapFiles = async ({ partner }) => {
  loaderService.show()
  try {
    const { data } = await apiService.get(`/gdc/hoja_ruta/archivos?solicitante=${partner}`)
    if (data.success) {
      return data
    }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}

export const postGDCRoadMapFile = async ({ params }) => {
  loaderService.show()
  try {
    const { data } = await apiService.post('/gdc/hoja_ruta/archivos', params)
    if (data.success) {
      return data
    }
  } catch (error) {
    // Handle error appropriately
    throw error
  } finally {
    loaderService.hide()
  }
}